import * as React from "react";
import {
  HashRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { LandingPage } from "../containers/LandingPage";
import { Partners } from "../containers/Partners";
import { NotFound } from "../components/Error";
import "antd/dist/antd.css";
import { routeURL } from "../constants/commons";
import { FeeStructure } from "../containers/FeeStructure";
import BasicLayout from "../layouts/BasicLayout";
import { RegistrationPage } from "../containers/RegistrationPage";
import { Dashboard } from "../containers/Dashboard";
import { CustomForm } from "../containers/CustomForm";
import { Congratulations } from "../containers/CongratulationsPage";
import { useUserContext } from "../hooks/cookieHooks";
import { AcceptAgreementPage } from "../containers/AcceptAgreementPage";
import { FAQPage } from "../containers/FAQPage";
import { TermsConditions } from "../containers/TermsConditionsPage";
import { PreSignedSelfieVideoPage } from "../containers/PreSignedSelfieVideoPage";
import { initGA, GA_PageView } from "../utils/reactGA";
interface IRoutesProps {}

const Routes = (props: IRoutesProps) => {
  const [isProfileUpdated, setIsProfileUpdated] = React.useState<boolean>();
  const isProfilePictureUpdated = (profileUpdated: boolean) => {
    setIsProfileUpdated(profileUpdated);
  };

  // Initialise GA
  if (process.env.NODE_ENV === "production") {
    if (window.location.hostname.includes("stage")) {
      initGA(process.env.REACT_APP_GA_STAGE_SECRET);
    } else {
      initGA(process.env.REACT_APP_GA_PROD_SECRET);
    }
  }

  if (!useUserContext().empId) {
    return (
      <Router>
        <Switch>
          <Route exact path={routeURL.partnerNewForm(":userId")}>
            <CustomForm />
          </Route>
          <Route
            exact
            path={routeURL.selfieVideoPreSignedURLPage(
              ":userId",
              ":uploadType"
            )}
          >
            <PreSignedSelfieVideoPage />
          </Route>
          <Route
            exact
            path={routeURL.feeStructurePage}
            render={() => {
              GA_PageView(routeURL.feeStructurePage);
              return (
                <BasicLayout>
                  <FeeStructure />
                </BasicLayout>
              );
            }}
          />
          {/* <BasicLayout>
              <FeeStructure />
            </BasicLayout>
          </Route> */}
          <Route
            exact
            path={routeURL.faqPage}
            render={() => {
              GA_PageView(routeURL.faqPage);
              return (
                <BasicLayout>
                  <FAQPage />
                </BasicLayout>
              );
            }}
          />
          {/* <BasicLayout>
              <FAQPage />
            </BasicLayout>
          </Route> */}
          <Route
            exact
            path={routeURL.landingPage}
            render={() => {
              GA_PageView(routeURL.landingPage);
              return (
                <BasicLayout>
                  <LandingPage />
                </BasicLayout>
              );
            }}
          />
          {/* <BasicLayout>
              <LandingPage />
            </BasicLayout>
          </Route> */}
          <Route
            exact
            path={routeURL.partnerPage(":partnerID")}
            render={() => {
              GA_PageView(routeURL.partnerPage(":partnerID"));
              return (
                <BasicLayout>
                  <Partners />
                </BasicLayout>
              );
            }}
          />
          {/* <BasicLayout>
              <Partners />
            </BasicLayout>
          </Route> */}
          <Route
            path={routeURL.notFoundscreen}
            render={() => {
              GA_PageView(routeURL.notFoundscreen);
              return (
                <BasicLayout>
                  <NotFound default />
                </BasicLayout>
              );
            }}
          />
          {/* <NotFound default />
          </Route> */}
          <Route exact path="*">
            <Redirect to={routeURL.notFoundscreen} />
          </Route>
        </Switch>
      </Router>
    );
  } else {
    return (
      <Router>
        <Switch>
          <Route exact path={routeURL.landingPage}>
            <Redirect to={routeURL.dashboard} />
          </Route>
          <Route
            exact
            path={routeURL.feeStructurePage}
            render={() => {
              GA_PageView(routeURL.feeStructurePage);
              return (
                <BasicLayout>
                  <FeeStructure />
                </BasicLayout>
              );
            }}
          />
          {/* <BasicLayout>
              <FeeStructure />
            </BasicLayout>
          </Route> */}
          <Route
            exact
            path={routeURL.faqPage}
            render={() => {
              GA_PageView(routeURL.faqPage);
              return (
                <BasicLayout>
                  <FAQPage />
                </BasicLayout>
              );
            }}
          />
          {/* <BasicLayout>
              <FAQPage />
            </BasicLayout>
          </Route> */}
          <Route exact path={routeURL.registrationPage}>
            <BasicLayout isProfilePictureUpdated={isProfileUpdated}>
              <RegistrationPage profilePicStatus={isProfilePictureUpdated} />
            </BasicLayout>
          </Route>
          <Route
            exact
            path={[routeURL.dashboard, routeURL.welcomeAboardScreen]}
          >
            <BasicLayout>
              <Dashboard />
            </BasicLayout>
          </Route>
          <Route exact path={routeURL.finalCongratulationsPage}>
            <BasicLayout>
              <Congratulations />
            </BasicLayout>
          </Route>
          <Route exact path={routeURL.finalAgreementPage}>
            <BasicLayout>
              <AcceptAgreementPage />
            </BasicLayout>
          </Route>
          <Route
            exact
            path={routeURL.termsConditionsPage}
            render={() => {
              GA_PageView(routeURL.termsConditionsPage);
              return (
                <BasicLayout>
                  <TermsConditions />
                </BasicLayout>
              );
            }}
          />
          {/* <BasicLayout>
              <TermsConditions />
            </BasicLayout>
          </Route> */}
          <Route
            path={routeURL.notFoundscreen}
            render={() => {
              GA_PageView(routeURL.notFoundscreen);
              return (
                <BasicLayout>
                  <NotFound default />
                </BasicLayout>
              );
            }}
          />
          {/* <NotFound default />
          </Route> */}
          <Route exact path="*">
            <Redirect to={routeURL.notFoundscreen} />
          </Route>
        </Switch>
      </Router>
    );
  }
};

export default Routes;
